export default __webpack_public_path__ + "static/media/Social_Insta.2d67d797.svg";